export const minus = 'M14,111v35H241V111Z'
